<template>
  <nav class="nav-panel">
    <RouterLink
      v-for="button in navButtons"
      v-slot="{ isActive }"
      :key="button.name"
      :to="`/lk/${button.name}`"
      class="nav-panel__item"
      active-class="nav-panel__item--active"
    >
      <SvgButton
        :class="{ 'nav-panel__icon--active': isActive }"
        height="14px"
        width="14px"
        class="nav-panel__icon"
        :name="button.name"
      />
      <span
        class="nav-panel__text"
        :class="{'nav-panel__text--active': isActive}"
      >
        {{ t('lk_navigation_panel.' + button.name) }}
      </span>
    </RouterLink>

    <button
      class="nav-panel__item"
      @click="store.isShowLogoutDialog = true"
    >
      <SvgButton
        height="14px"
        width="14px"
        class="nav-panel__icon"
        name="exit"
      />
      <span class="nav-panel__text">
        {{ t('lk_navigation_panel.exit') }}
      </span>
    </button>
  </nav>
</template>

<script setup>
import SvgButton from "@/components/common/svgButton.vue";
import {buttons} from "@/composables/constans/buttonTypes";
import {useStore} from "@/store";
import { t } from "@/controllerLK/GlobusLocalization";

const store = useStore();

const navButtons = buttons.filter(b => b.name !== "exit");
</script>

<style lang="scss" scoped>

.nav-panel {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 238px;
  width: 238px;
  min-height: 700px;
  padding: 14px;
  border-radius: 8px;
  background-color: var(--white);
  box-shadow: 2px 4px 20px 0 #0020390F;
  gap: 4px;
}

.nav-panel__item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;

  &:hover {
    background-color: var(--background-bg-hover);

    .nav-panel__icon {
      color: var(--icon-icon-on);
    }
  }

  &--active {
    background-color: var(--background-bg-hover);
  }
}

.nav-panel__icon {
  color: #A7A7A7;

  &--active {
    color: var(--icon-icon-on);
  }
}

.nav-panel__text {
  color: #373D3F;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  &--active {
    color: var(--text-text-on);
  }
}
</style>
